import { GeoZoneGracePeriod } from '../components/AddGeoZones';
import { getGracePeriods } from '.';

interface GracePeriodUpdateConfig {
  currentGracePeriods: Required<GeoZoneGracePeriod>[];
  isZeroGracePeriod: boolean;
}

export const DEFAULT_MIN_GRACE_PERIOD = '60';
export const ZERO_GRACE_PERIOD = '0';

export const applyZeroGracePeriod = (currentGracePeriods: Required<GeoZoneGracePeriod>[]) => {
    return currentGracePeriods.map((period) => {
        return {
            ...period,
            GracePeriod: ZERO_GRACE_PERIOD,
        };
    });
};

export const applyStandardGracePeriod = (currentGracePeriods: Required<GeoZoneGracePeriod>[]) => {
  return currentGracePeriods.map((period) => {
    const totalSeconds = getGracePeriods(period.GracePeriod);
    return {
      ...period,
      GracePeriod: totalSeconds < 10 ? DEFAULT_MIN_GRACE_PERIOD : period.GracePeriod,
    };
  });
};

export const updateGracePeriods = ({ currentGracePeriods, isZeroGracePeriod }: GracePeriodUpdateConfig) => {
  return isZeroGracePeriod
    ? applyZeroGracePeriod(currentGracePeriods)
    : applyStandardGracePeriod(currentGracePeriods);
};
